import { connect } from 'react-redux';
import { branch, compose, lifecycle, renderNothing, withHandlers } from 'recompose';

import { setTip } from '../actions';
import { xor } from '../../utils/helpers';
import WithToggle from '../../hoc/WithToggle';
import { getNoExtrasForReserveNoPay } from '../../shops/selectors';
import WithKioskProp from '../../hoc/WithKioskProp';
import WithApplePayQuery from '../../hoc/WithApplePayQuery';
import WithBookNoPayQuery from '../../hoc/WithBookNoPayQuery';
import withRouteParameters from './withRouteParameters';
import { getHasCustomTip, getTips, getCustomTip, getTotalAmount } from '../selectors';
import analytics
  from '../../applicationServices/analytics/BookingAnalytics';

const mapStateToProps = (state, ownProps) => ({
  tips: getTips(state),
  hasCustomTip: getHasCustomTip(state),
  customTip: getCustomTip(state),
  total: getTotalAmount(state),
  noExtrasForBookNoPay: getNoExtrasForReserveNoPay(state, ownProps.shopRoute),
});

const mapDispatchToProps = {
  onTipSelect: setTip,
};

export default compose(
  withRouteParameters,
  WithApplePayQuery,
  WithKioskProp,
  WithToggle,
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onTipSelect: props => (value) => {
      analytics.tipSelected();
      props.onTipSelect(value);
      if (props.toggled) {
        props.off();
      }
    },
  }),
  WithBookNoPayQuery,
  branch((props) => {
    if (props.bookNoPayQuery) return true;
    if (!props.tipEnabled) return true;
    return xor(props.showOnApplePay, props.withApplePay);
  }, renderNothing),
  lifecycle({
    componentDidMount() {
      analytics.tipOptionActive();
    },
  })
);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/TipSharedContainer.js